import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';
import SectionHeader from './SectionHeader';
import { PRODUCTS, SITE } from '../config/site';

export default function ProductsPortfolioSection({ creative = false, compact = false }) {
  const enterprise = PRODUCTS.filter((p) => p.pagePath);
  const consumer = PRODUCTS.filter((p) => p.isFlagship);

  return (
    <section
      id="products"
      className={`section products-portfolio${creative ? ' products-portfolio--creative' : ''}`}
    >
      <div className="container">
        <SectionHeader
          creative={creative}
          light={creative}
          align="center"
          label="Our products"
          title="Software we build and operate"
          description={`${SITE.shortName} ships enterprise platforms for IoT, telecom, and network ops — plus our live consumer marketplace.`}
        />

        <div className="products-showcase">
          <p className="products-portfolio__split-label">Enterprise platforms</p>
          <div
            className={`products-grid products-grid--enterprise${compact ? ' products-grid--compact' : ''}`}
          >
            {enterprise.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                variant={compact ? 'compact' : 'grid'}
              />
            ))}
          </div>

          {consumer.length > 0 && (
            <>
              <p className="products-portfolio__split-label">Consumer platform</p>
              <div className="products-grid products-grid--consumer">
                {consumer.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    variant="featured"
                  />
                ))}
              </div>
            </>
          )}
        </div>

        <p className="products-portfolio__footer">
          <Link to="/demo" className="btn btn--primary">
            Request a product demo
          </Link>
          <Link to="/products" className="link-muted">
            View full product details →
          </Link>
        </p>
      </div>
    </section>
  );
}
